"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BannerWithInlineContent = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _styled = require("../styled.banners");

var _bannerWithInlineContentProps = require("./bannerWithInlineContentProps");

var _bannerWithInlineContentProps2 = _interopRequireDefault(_bannerWithInlineContentProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BannerWithInlineContent = exports.BannerWithInlineContent = function BannerWithInlineContent(props) {
  var newProps = _extends({}, _bannerWithInlineContentProps2.default.props, props);

  var style = newProps.style,
      body = newProps.body;


  return _react2.default.createElement(
    _styled.StyledSection,
    {
      className: "position-relative mb-4",
      bgImage: style.backgroundImg,
      color: style.ContentColor,
      contentFontSize: style.contentFontSize
    },
    _react2.default.createElement(
      _reactBootstrap.Container,
      null,
      _react2.default.createElement(
        _reactBootstrap.Row,
        { className: "align-items-center" },
        _react2.default.createElement(
          _reactBootstrap.Col,
          { md: "6", className: "mb-5 mb-md-0 pr-xl-5" },
          _react2.default.createElement(
            _styled.Title,
            {
              titleFontSize: style.headingFontSize,
              titleColor: style.headingColor,
              className: "mb-4",
              titleAlign: style.headingAlign
            },
            body.title
          ),
          _react2.default.createElement(
            "p",
            { className: "mb-4" },
            body.content
          ),
          _react2.default.createElement(
            _styled.StyledLink,
            {
              btnType: true,
              btnRadius: style.buttonRadius,
              btnColor: style.buttonColor,
              fontSize: style.buttonFontSize,
              bgColor: style.buttonBg,
              borderColor: style.buttonBorderColor,
              hoverBgColor: style.buttonHoverBg,
              hoverColor: style.buttonHoverColor,
              hoverBorderColor: style.hoverBorderColor,
              href: body.linkUrl
            },
            body.linkTitle
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Col,
          { md: "6" },
          _react2.default.createElement("img", { src: body.img, alt: body.alt })
        )
      )
    )
  );
};

exports.default = BannerWithInlineContent;